export default function trimNonCicularRangeByAnotherNonCircularRange(rangeToBeTrimmed, trimmingRange) {
  let outputTrimmedRange;
  if (!rangeToBeTrimmed) {
    return outputTrimmedRange;
  }
  if (rangeToBeTrimmed.start < trimmingRange.start) {
    if (rangeToBeTrimmed.end < trimmingRange.start) {
      outputTrimmedRange = {
        start: rangeToBeTrimmed.start,
        end: rangeToBeTrimmed.end
      };
    } else {
      if (rangeToBeTrimmed.end > trimmingRange.end) {
        outputTrimmedRange = {
          start: rangeToBeTrimmed.start,
          end: rangeToBeTrimmed.end
        };
      } else {
        outputTrimmedRange = {
          start: rangeToBeTrimmed.start,
          end: trimmingRange.start - 1
        };
      }
    }
  } else {
    if (rangeToBeTrimmed.end <= trimmingRange.end) {
    } else {
      if (rangeToBeTrimmed.start > trimmingRange.end) {
        outputTrimmedRange = {
          end: rangeToBeTrimmed.end,
          start: rangeToBeTrimmed.start
        };
      } else {
        outputTrimmedRange = {
          end: rangeToBeTrimmed.end,
          start: trimmingRange.end + 1
        };
      }
    }
  }
  return outputTrimmedRange;
}
